/*
  MANISH CUSTOM CODE (2026-11-04) - SUBSCRIPTION KEEPS THE CHOSEN FRAGRANCES - START

  Subscriptions are paid in the Easy Subscriptions popup (subx-custom-popup.js), not in
  Shopify's checkout, and the app creates the order itself. That script:
    - "Subscribe Now": sent only product, plan and quantity, so the fragrances picked in the
      "Choose N Fragrances" picker (properties[Fragrance 1] ...) never left the page;
    - cart checkout: sent them, but the popup never showed them.
  This add-on (loaded from snippets/scripts.liquid) leaves that file untouched and:
    1. adds the product form's line properties to the "Subscribe Now" request
       (as `properties`, the same shape the cart request already uses per item);
    2. shows the chosen fragrances in the popup summary (single product and cart);
    3. stops "Subscribe Now" opening the popup before the fragrances are chosen - it opens
       the fragrance picker instead, exactly like Add to cart.
*/
(function () {
  'use strict';
  if (window.__mmSubxFragranceFix) return;
  window.__mmSubxFragranceFix = true;

  // Every filled properties[...] field of an add-to-cart form, as { name: value }.
  function formProperties(form) {
    var out = {};
    if (!form) return out;
    form.querySelectorAll('input[name^="properties["]').forEach(function (el) {
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var key = el.name.slice(11, -1);
      var val = (el.value || '').trim();
      if (key && val) out[key] = val;
    });
    return out;
  }

  // Only what a customer should read: no _hidden keys, no empty app fields.
  function visibleLines(props) {
    var skip = { 'Recurring': 1, 'Free Gift Items': 1 };
    return Object.keys(props || {}).filter(function (k) {
      return k.charAt(0) !== '_' && !skip[k] && String(props[k] || '').trim();
    }).map(function (k) { return k + ': ' + props[k]; });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // 1. "Subscribe Now" request carries the form's properties.
  //    This file may load before subx-custom-popup.js (it is in <head>), so the wrap is
  //    retried at DOMContentLoaded - which fires after every deferred script has run and
  //    before the subscription script boots (its listener is added later than ours).
  function wrapGetData() {
    var fn = window.getSubxPopupData;
    if (typeof fn !== 'function' || fn.__mmWrapped) return typeof fn === 'function';
    var wrapped = function (form) {
      var data = fn.apply(this, arguments);
      if (data) data.properties = formProperties(form);
      return data;
    };
    wrapped.__mmWrapped = true;
    window.getSubxPopupData = wrapped;
    return true;
  }

  // 3. Fragrances must be chosen before "Subscribe Now" opens the payment popup.
  //    Capture phase on document runs before the button's own click handler.
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('.subx__subscribe-btn');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;
    var picker = form.querySelector('mm-options-modal') ||
      (form.closest('product-form-component') || document).querySelector('mm-options-modal');
    if (!picker) return;
    var chosen = form.querySelector('input[name="properties[_mm_fragrance_selected]"]');
    if (chosen && chosen.value === 'true') return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (typeof picker.openModal === 'function') picker.openModal();
  }, true);

  function patchPopup() {
    var popup = window.SUBXCheckoutPopup;
    if (!popup) return false;
    var proto = Object.getPrototypeOf(popup);
    if (!proto || proto.__mmFragrancePatched) return true;
    proto.__mmFragrancePatched = true;

    // 1b. The final request (pre-order) carries them too.
    if (typeof proto._getFormData === 'function') {
      var originalFormData = proto._getFormData;
      proto._getFormData = function () {
        var data = originalFormData.apply(this, arguments) || {};
        var o = this._options || {};
        if (!o.isCart && o.properties) data.properties = o.properties;
        return data;
      };
    }

    // 2a. Single product summary: "Fragrance 1: ..., Fragrance 2: ..." under the variant.
    if (typeof proto._fillSummary === 'function') {
      var originalFill = proto._fillSummary;
      proto._fillSummary = function () {
        var result = originalFill.apply(this, arguments);
        var o = this._options || {};
        var old = document.getElementById('mm-subx-props');
        if (old) old.remove();
        if (o.isCart) return result;
        var lines = visibleLines(o.properties);
        var variantEl = document.getElementById('subx__cp-variant-display');
        if (lines.length && variantEl) {
          var box = document.createElement('div');
          box.id = 'mm-subx-props';
          box.style.cssText = 'margin-top:6px;font-size:13px;line-height:1.5;color:#111;';
          box.innerHTML = lines.map(function (l) { return '<div>' + escapeHtml(l) + '</div>'; }).join('');
          variantEl.insertAdjacentElement('afterend', box);
        }
        return result;
      };
    }

    // 2b. Cart summary: each line lists its own fragrances.
    if (typeof proto._fillCartSummary === 'function') {
      var originalCartFill = proto._fillCartSummary;
      proto._fillCartSummary = function () {
        var result = originalCartFill.apply(this, arguments);
        var o = this._options || {};
        var items = (o.cart && o.cart.items) || [];
        var list = document.getElementById('subx__cp-cart-lines');
        if (!list) return result;
        Array.prototype.forEach.call(list.children, function (row, i) {
          var lines = visibleLines(items[i] && items[i].properties);
          var textCol = row.children[1];
          if (!lines.length || !textCol || textCol.querySelector('.mm-subx-line-props')) return;
          var box = document.createElement('div');
          box.className = 'mm-subx-line-props';
          box.style.cssText = 'font-size:11px;color:#333;line-height:1.45;margin-top:2px;';
          box.innerHTML = lines.map(function (l) { return '<div>' + escapeHtml(l) + '</div>'; }).join('');
          var title = textCol.firstElementChild;
          if (title) title.insertAdjacentElement('afterend', box); else textCol.appendChild(box);
        });
        return result;
      };
    }
    return true;
  }

  function patchAll() {
    wrapGetData();
    patchPopup();
  }
  patchAll();
  document.addEventListener('DOMContentLoaded', patchAll);
  window.addEventListener('load', patchAll);
})();
/* MANISH CUSTOM CODE - SUBSCRIPTION KEEPS THE CHOSEN FRAGRANCES - END */
